var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMasterYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.861,
    height: 47.282,
    viewBox: "0 0 73.861 47.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7510",
    "data-name": "Path 7510",
    d: "M318.289,231.832H333.9V209.757a22.077,22.077,0,1,0-44.154,0V219.4a10.573,10.573,0,0,0,3.029-2.124l.552-.552,9.184,9.184-.552.552a23.482,23.482,0,0,1-8.268,5.366h11.691a6.506,6.506,0,0,1,12.9,0Zm-6.454-15.581a6.506,6.506,0,1,1,6.506-6.493A6.506,6.506,0,0,1,311.835,216.25Z",
    transform: "translate(-289.75 -187.68)",
    fill: "#5ce5bb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14476",
    "data-name": "Group 14476",
    transform: "translate(-1397 -159.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5735",
    "data-name": "Path 5735",
    d: "M187.63,209.752A22.087,22.087,0,0,1,208,187.735c.571-.042,1.141-.065,1.708-.065a22.1,22.1,0,0,1,11.972,3.513l-.135.117a23.782,23.782,0,0,0-6.21,7.547l-.023.044a12.216,12.216,0,1,0,2.483,20.039l6.988,6.988a22.082,22.082,0,0,1-37.133-16.159Z",
    transform: "translate(1210.931 -26.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5736",
    "data-name": "Path 5736",
    d: "M318.289,231.832H333.9V209.757a22.077,22.077,0,1,0-44.154,0V219.4a10.573,10.573,0,0,0,3.029-2.124l.552-.552,9.184,9.184-.552.552a23.482,23.482,0,0,1-8.268,5.366h11.691a6.506,6.506,0,0,1,12.9,0Zm-6.454-15.581a6.506,6.506,0,1,1,6.506-6.493A6.506,6.506,0,0,1,311.835,216.25Z",
    transform: "translate(1135.388 -26.988)",
    fill: "#5ce5bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5737",
    "data-name": "Path 5737",
    d: "M231.856,181.66a23.5,23.5,0,0,0-13.273,4.094,23.641,23.641,0,1,0-13.515,43.181h21.861v-.781a4.945,4.945,0,0,1,9.866,0v.781h18.7V205.3A23.665,23.665,0,0,0,231.856,181.66ZM208.217,205.3v10.238a10.649,10.649,0,1,1,1.973-19.685A23.5,23.5,0,0,0,208.217,205.3Zm-25.023,0a22.087,22.087,0,0,1,20.367-22.017c.571-.042,1.141-.065,1.708-.065a22.1,22.1,0,0,1,11.972,3.513l-.135.117a23.782,23.782,0,0,0-6.21,7.547l-.023.044a12.216,12.216,0,1,0,2.483,20.039l6.988,6.988a22.082,22.082,0,0,1-37.133-16.159Zm70.739,22.072H238.318a6.506,6.506,0,0,0-12.9,0H213.763A23.487,23.487,0,0,0,222,222.02l.552-.552h0l-9.192-9.2-.552.552a10.571,10.571,0,0,1-3.029,2.124V205.3a22.081,22.081,0,0,1,42.7-7.9,21.852,21.852,0,0,1,1.454,7.9Z",
    transform: "translate(1215.367 -22.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5738",
    "data-name": "Path 5738",
    d: "M356.116,247.55a6.506,6.506,0,1,0,6.506,6.506A6.506,6.506,0,0,0,356.116,247.55Zm0,11.428a4.945,4.945,0,1,1,4.945-4.932A4.945,4.945,0,0,1,356.116,258.978Z",
    transform: "translate(1091.106 -71.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7508",
    "data-name": "Path 7508",
    d: "M318.289,231.832H333.9V209.757a22.077,22.077,0,1,0-44.154,0V219.4a10.573,10.573,0,0,0,3.029-2.124l.552-.552,9.184,9.184-.552.552a23.482,23.482,0,0,1-8.268,5.366h11.691a6.506,6.506,0,0,1,12.9,0Zm-6.454-15.581a6.506,6.506,0,1,1,6.506-6.493A6.506,6.506,0,0,1,311.835,216.25Z",
    transform: "translate(1135.388 -26.988)",
    fill: "#f0eb4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(1425.138 160.692)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(-17.093 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M-6.862,299.291-10.8,306.1H-2.91Z",
    transform: "translate(14.762 -258.391)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M-6.862,198.952-10.8,205.78H-2.91Z",
    transform: "translate(14.762 -171.691)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M-6.862,98.737l-3.935,6.811H-2.91Z",
    transform: "translate(14.762 -85.098)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M51.154,299.291,47.219,306.1h7.886Z",
    transform: "translate(-35.368 -258.391)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M109.169,299.291l-3.935,6.811h7.886Z",
    transform: "translate(-85.497 -258.391)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M167.185,299.291,163.25,306.1h7.869Z",
    transform: "translate(-135.627 -258.391)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M225.092,299.291l-3.951,6.811h7.886Z",
    transform: "translate(-185.649 -258.391)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M283.109,299.291l-3.951,6.811h7.886Z",
    transform: "translate(-235.779 -258.391)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M341.124,299.291l-3.951,6.811h7.886Z",
    transform: "translate(-285.909 -258.391)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M399.139,299.291l-3.951,6.811h7.886Z",
    transform: "translate(-336.038 -258.391)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M22.1,249.184l-3.951,6.811h7.886Z",
    transform: "translate(-10.25 -215.095)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M-36.016,249.184l-3.951,6.811h7.886Z",
    transform: "translate(39.967 -215.095)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M80.116,249.184l-3.952,6.811h7.886Z",
    transform: "translate(-60.379 -215.095)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M138.131,249.184l-3.951,6.811h7.886Z",
    transform: "translate(-110.508 -215.095)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M196.131,249.184l-3.935,6.811h7.886Z",
    transform: "translate(-160.638 -215.095)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M254.146,249.184l-3.935,6.811H258.1Z",
    transform: "translate(-210.767 -215.095)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M312.162,249.184l-3.935,6.811h7.886Z",
    transform: "translate(-260.897 -215.095)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M370.177,249.184l-3.935,6.811h7.886Z",
    transform: "translate(-311.026 -215.095)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M427.967,249.184l-3.934,6.811h7.886Z",
    transform: "translate(-360.962 -215.095)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M51.154,198.952l-3.935,6.828h7.886Z",
    transform: "translate(-35.368 -171.691)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M109.169,198.952l-3.934,6.828h7.886Z",
    transform: "translate(-85.498 -171.691)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M167.185,198.952l-3.935,6.828h7.869Z",
    transform: "translate(-135.627 -171.691)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M225.093,198.952l-3.951,6.828h7.886Z",
    transform: "translate(-185.65 -171.691)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M283.109,198.952l-3.951,6.828h7.886Z",
    transform: "translate(-235.779 -171.691)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M341.124,198.952l-3.951,6.828h7.886Z",
    transform: "translate(-285.909 -171.691)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M399.139,198.952l-3.951,6.828h7.886Z",
    transform: "translate(-336.038 -171.691)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M80.116,148.845l-3.952,6.811h7.886Z",
    transform: "translate(-60.379 -128.395)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M138.131,148.845l-3.951,6.811h7.886Z",
    transform: "translate(-110.508 -128.395)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M196.131,148.845l-3.935,6.811h7.886Z",
    transform: "translate(-160.638 -128.395)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M22.1,148.845l-3.951,6.811h7.886Z",
    transform: "translate(-10.25 -128.395)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M22.2,148.845l-3.951,6.811h7.886Z",
    transform: "translate(-10.332 -128.395)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M-36.016,148.845l-3.951,6.811h7.886Z",
    transform: "translate(39.967 -128.395)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M-35.921,148.845l-3.951,6.811h7.886Z",
    transform: "translate(39.885 -128.395)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M254.146,148.845l-3.935,6.811H258.1Z",
    transform: "translate(-210.767 -128.395)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M312.162,148.845l-3.935,6.811h7.886Z",
    transform: "translate(-260.897 -128.395)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M370.177,148.845l-3.935,6.811h7.886Z",
    transform: "translate(-311.026 -128.395)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M427.967,148.845l-3.934,6.811h7.886Z",
    transform: "translate(-360.962 -128.395)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M109.169,98.737l-3.934,6.811h7.886Z",
    transform: "translate(-85.498 -85.098)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M51.154,98.737l-3.935,6.811h7.886Z",
    transform: "translate(-35.368 -85.098)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M167.185,98.737l-3.935,6.811h7.869Z",
    transform: "translate(-135.627 -85.098)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M225.093,98.737l-3.951,6.811h7.886Z",
    transform: "translate(-185.65 -85.098)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M283.109,98.737l-3.951,6.811h7.886Z",
    transform: "translate(-235.779 -85.098)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M341.124,98.737l-3.951,6.811h7.886Z",
    transform: "translate(-285.909 -85.098)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M399.139,98.737l-3.951,6.811h7.886Z",
    transform: "translate(-336.038 -85.098)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M138.131,48.506l-3.951,6.828h7.886Z",
    transform: "translate(-110.508 -41.695)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M196.131,48.506,192.2,55.334h7.886Z",
    transform: "translate(-160.638 -41.695)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M254.146,48.506l-3.935,6.828H258.1Z",
    transform: "translate(-210.767 -41.695)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M312.162,48.506l-3.935,6.828h7.886Z",
    transform: "translate(-260.897 -41.695)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M22.1,48.506,18.15,55.334h7.886Z",
    transform: "translate(-10.25 -41.695)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M-36.016,48.506l-3.951,6.828h7.886Z",
    transform: "translate(39.967 -41.695)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M80.116,48.506l-3.952,6.828h7.886Z",
    transform: "translate(-60.379 -41.695)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M370.177,48.506l-3.935,6.828h7.886Z",
    transform: "translate(-311.026 -41.695)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M427.967,48.506l-3.934,6.828h7.886Z",
    transform: "translate(-360.962 -41.695)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M109.169-1.6,105.235,5.21h7.886Z",
    transform: "translate(-85.498 1.602)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M167.185-1.6,163.25,5.21h7.869Z",
    transform: "translate(-135.627 1.602)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M225.093-1.6,221.142,5.21h7.886Z",
    transform: "translate(-185.65 1.602)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M283.109-1.6,279.157,5.21h7.886Z",
    transform: "translate(-235.779 1.602)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M-6.862-1.6-10.8,5.21H-2.91Z",
    transform: "translate(14.762 1.602)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M51.154-1.6,47.219,5.21h7.886Z",
    transform: "translate(-35.368 1.602)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M341.123-1.6,337.172,5.21h7.886Z",
    transform: "translate(-285.908 1.602)",
    fill: "#ff6933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M398.814-1.6,394.862,5.21h7.886Z",
    transform: "translate(-335.756 1.602)",
    fill: "#ff6933"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMasterYellow);
export default __webpack_public_path__ + "static/media/logo-master-yellow.c69c64c7910157433d950f6648e7a93d.svg";
export { ForwardRef as ReactComponent };